<template>
  <div class="c-loading flex-column-center">
    <div class="loading-content flex-center">
      <div class="loading"></div>
    </div>
    <img class="icon-chanel-text" src="@/assets/icons/icon-chanel-text.svg" />
  </div>
</template>
<script setup lang="ts"></script>
<style lang="less" scoped>
.c-loading {
  position: absolute;
  width: 100vw;
  height: 100vh;
  left: 0px;
  top: 0px;
  background: #000;
  color: #fff;
  z-index: 300;
  overflow: visible;
  pointer-events: none;
  // opacity: 0.2;

  &::before,
  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 1px;
    background: #000;
    left: 0px;
  }
  &::before {
    top: -0.5px;
  }
  &::after {
    bottom: -0.5px;
  }

  .loading-content {
    width: 44px;
    height: 44px;
    padding: 1.3px;
    left: 50%;
    margin-left: -22px;
    border-radius: 50%;
    margin: 0 auto;
    background-image: linear-gradient(-90deg, #000, #fff 70%);
    opacity: 0.6;
    animation: loadingAni 1s linear infinite;
    transform: scale(1.2) translate(2px, 4px);
  }

  .loading {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: #000;
  }

  .icon-chanel-text {
    width: 94px;
    height: fit-content;
    margin-top: 26px;
  }

  @keyframes loadingAni {
    from {
      transform: rotate(0deg) scale(1.2);
    }
    to {
      transform: rotate(1turn) scale(1.2);
    }
  }
}
</style>
